const _excluded = ["classes", "shape"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
/**
 * Image module.
 * @module @massds/mayflower-react/Image
 * @requires module:@massds/mayflower-assets/scss/01-atoms/image
 */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
const Image = props => {
  var _classNames;
  const classes = props.classes,
    shape = props.shape,
    imgProps = _objectWithoutPropertiesLoose(props, _excluded);
  const imageClasses = classNames((_classNames = {
    ma__image: true
  }, _classNames[shape] = shape, _classNames[classes && classes.join(' ')] = classes, _classNames));
  // eslint-disable-next-line jsx-a11y/alt-text
  return /*#__PURE__*/React.createElement("img", _extends({
    className: imageClasses
  }, imgProps));
};
Image.propTypes = process.env.NODE_ENV !== "production" ? {
  classes: PropTypes.arrayOf(PropTypes.string),
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  shape: PropTypes.string
} : {};
Image.defaultProps = {
  alt: '',
  shape: ''
};
export default Image;